export const TEXTS = {
  EMPTY_TEXT: 'Тут пока ничего нет, ',
  EMPTY_TEXT_HINT: 'но скоро появятся отчеты, и вы сможете их выгрузить',
};
